export function formatSum(sum: number): string {
  return sum.toLocaleString('ru-RU');
}